import { FormikProps } from 'formik';
import { ISettingsValues } from '../../Settings';
import { IMenuItem, InputFormik, SearchableDropdown } from '../../../components/Common';
import { BusinessTypeEnum, IndustryEnum, NumOfEmplyeesEnum } from '../../../commonTypes/organization.types';
import { EditableLabelInputFormik } from '../../../components/Common/EditableInput';

interface IAdditionalSettings<ISettingsValues> {
    context: FormikProps<ISettingsValues>;
}

const mapEnumToMenuItems = (enumObj: any): IMenuItem[] => {
    return Object.keys(enumObj).map(key => ({
        value: enumObj[key],
        label: enumObj[key],
    }));
};

const AdditionalSettings = ({ context }: IAdditionalSettings<ISettingsValues>) => {
    const { setFieldValue } = context;

    return (
        <div className="additional-settings">
            <InputFormik id="website" context={context} label="Website" />
            <SearchableDropdown
                label="Industry"
                menuItems={mapEnumToMenuItems(IndustryEnum)}
                onChange={item => {
                    setFieldValue('industry', item.value);
                }}
                selected={{ value: context.values.industry ?? '', label: context.values.industry ?? '' }}
            />
            <SearchableDropdown
                label="Number of employees"
                menuItems={mapEnumToMenuItems(NumOfEmplyeesEnum)}
                onChange={item => {
                    setFieldValue('numberOfEmployees', item.value);
                }}
                selected={{ value: context.values.numberOfEmployees ?? '', label: context.values.numberOfEmployees ?? '' }}
            />
            <SearchableDropdown
                label="Business type"
                menuItems={mapEnumToMenuItems(BusinessTypeEnum)}
                onChange={item => {
                    setFieldValue('businessType', item.value);
                }}
                selected={{ value: context.values.businessType ?? '', label: context.values.businessType ?? '' }}
            />
            <EditableLabelInputFormik
                id="registrationNumber"
                context={context}
                label={context.values.registrationNumberLabel}
                onLabelChange={newLabel => setFieldValue('registrationNumberLabel', newLabel)}
            />
            <EditableLabelInputFormik
                id="taxNumber"
                context={context}
                label={context.values.taxNumberLabel}
                onLabelChange={newLabel => setFieldValue('taxNumberLabel', newLabel)}
            />
        </div>
    );
};

export default AdditionalSettings;
